import React from 'react'
import { Space, DatePicker, Button, Tooltip, Typography } from 'antd'
import { FileExcelOutlined, FilePdfOutlined, PrinterOutlined, BarChartOutlined } from '@ant-design/icons'
import styles from './ReportsHeader.module.css'

const { Title } = Typography
const { RangePicker } = DatePicker

const ReportsHeader = ({ dateRange, setDateRange, activeTab }) => {
  const handleExport = (type) => {
    // TODO: Implement export functionality
  }

  const handlePrint = () => {
    window.print()
  }

  return (
    <div className={styles.reportsHeader}>
      <div className={styles.reportsTitleSection}>
        <Space>
          <BarChartOutlined className={styles.reportsHeaderIcon} />
          <Title level={4} className={styles.reportsHeaderTitle}>
            Reports & Analytics
          </Title>
        </Space>
      </div>

      <div className={styles.reportsHeaderControls}>
        <Space size={16}>
          <RangePicker value={dateRange} onChange={setDateRange} allowClear={false} />

          <Space>
            <Tooltip title='Export as Excel'>
              <Button icon={<FileExcelOutlined />} onClick={() => handleExport('excel')} />
            </Tooltip>
            <Tooltip title='Export as PDF'>
              <Button icon={<FilePdfOutlined />} onClick={() => handleExport('pdf')} />
            </Tooltip>
            <Tooltip title='Print Report'>
              <Button icon={<PrinterOutlined />} onClick={handlePrint} />
            </Tooltip>
          </Space>
        </Space>
      </div>
    </div>
  )
}

export default ReportsHeader
